import { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import './styles/globals.css';

// Lazy load the Admin page (and its heavy dependencies like Recharts)
const Admin = lazy(() => import('./pages/Admin'));
const AllProjects = lazy(() => import('./pages/AllProjects'));
const MentionsLegales = lazy(() => import('./pages/MentionsLegales'));
const CGV = lazy(() => import('./pages/CGV'));
const AdminEmailGenerator = lazy(() => import('./pages/AdminEmailGenerator'));
const AdminProspects = lazy(() => import('./pages/AdminProspects'));
const BriefForm = lazy(() => import('./pages/BriefForm'));

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div className="min-h-screen bg-[#0a0e0d]"></div>}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/projets" element={<AllProjects />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/cgv" element={<CGV />} />
          <Route path="/admin/email-generator" element={<AdminEmailGenerator />} />
          <Route path="/admin/prospects" element={<AdminProspects />} />
          <Route path="/brief/:token" element={<BriefForm />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;

